import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/user.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';
import * as security from '../../../../actions/session.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Error from '../../../dialogs/Error';
import Menu from '../Menu';
import FilterMenu from './FilterMenu';
import List from './List';
import { AddIcon, FilterIcon } from '../../../../images/icons/WrapSvg';

function toolbar(handleFilter, secondary = false) {
    const color = secondary ? 'secondary' : 'primary';
    return <FilterIcon key={'filter-menu-toolbar'} color={color} onClick={handleFilter} />;
}

class Employees extends React.Component {
    state = {
        hide: false,
        open: undefined,
        all_employees: false,
        local: undefined,
        rol: undefined,
        window_searchs: this.props.window_searchs,
    };

    constructor(props) {
        super(props);
        props.loadUsers(undefined, undefined);
    }

    componentDidMount() {
        const tools = [toolbar(this.handleFilter)];
        this.props.setTools(tools);
        this.props.setSearch(true);
        this.props.setInventoryWindow("user");
        this.props.loadBasicInfo();
    }

    componentWillUnmount() {
        this.props.setTools([]);
        this.props.setSearch(false);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.users_has_error) {
            props.loadUsers(undefined, undefined);
            return {
                hide: false,
                open: undefined,
                all_employees: false,
                local: undefined,
                rol: undefined,
            };
        } else if (props.window_searchs !== state.window_searchs) {
            state.window_searchs = props.window_searchs;
            return state;
        }
        return null;
    }

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (active, rol, local) => {
        if (active === null) {
            this.setState({ open: undefined });
        } else {
            const tools = [toolbar(this.handleFilter, active || rol || local)];
            this.props.setTools(tools);

            this.props.loadUsers(rol, local);
            this.setState({ open: undefined, all_employees: active, rol: rol, local: local });
        }
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = event => {
        this.props.history.push('/manage/new_user');
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '64') &&
                info.security.licencias.some((f) => f.id === 152 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            const { open, all_employees, rol, local, window_searchs } = this.state;
            const addAvailable = info.security.licencias.some((f) => f.id === 152 && f.activo && (f.quota > f.quotaUsed || f.quota === -1));
            const licencia = info.security.licencias.find((f) => f.id === 152);
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full_column overflow_y_scroll center height100 bg_ice_blue showbar'}>
                        <List search={[...window_searchs]} licencia={licencia} all_employees={all_employees} />
                        <Fab
                            aria-label="add"
                            disabled={!addAvailable}
                            className={'button_float ' + (addAvailable ? ' bg_bluish c_white' : ' bg_disabled c_white')}
                            onClick={this.handleClick}
                        >
                            <AddIcon />
                        </Fab>
                    </div>
                    {open && (
                        <FilterMenu
                            anchorEl={open}
                            active={all_employees}
                            rol={rol}
                            local={local}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                </div>
            );
        }
    }
}

Employees.propTypes = {
    users_is_loading: PropTypes.bool.isRequired,
    users_has_errored: PropTypes.object.isRequired,
    window_searchs: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        users_is_loading: state.users_is_loading,
        users_has_errored: state.users_has_errored,
        window_searchs: state.window_searchs,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, inventory, security), dispatch);
};

Employees = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Employees);

Employees = withRouter(Employees);

export default Employees;



// WEBPACK FOOTER //
// ./src/components/complex/manage/users/Index.js